interface TabPanelProps {
  children?: React.ReactNode;
  id: string;
  value: string;
}
export const TabPanel = ({ children, value, id }: TabPanelProps) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== id}
      id={`tabpanelData-${id}`}
      aria-labelledby={`tabpanelData-${id}`}
      data-testid={`tabpanelData-${id}`}>
      {value === id && <div>{children}</div>}
    </div>
  );
};
